var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-link",
    "data-name": "Icon awesome-link",
    d: "M12.12,6.88a5.638,5.638,0,0,1,.013,7.963l-.013.014L9.627,17.351A5.641,5.641,0,0,1,1.65,9.373L3.027,8a.593.593,0,0,1,1.013.394,6.838,6.838,0,0,0,.36,1.956.6.6,0,0,1-.14.616l-.486.486a2.672,2.672,0,1,0,3.754,3.8l2.494-2.493a2.671,2.671,0,0,0,0-3.779,2.78,2.78,0,0,0-.384-.318.6.6,0,0,1-.258-.468,1.478,1.478,0,0,1,.434-1.106l.781-.781a.6.6,0,0,1,.764-.064,5.659,5.659,0,0,1,.762.638Zm5.23-5.23a5.647,5.647,0,0,0-7.977,0L6.88,4.143l-.013.014a5.642,5.642,0,0,0,.775,8.6.6.6,0,0,0,.764-.064l.781-.781a1.478,1.478,0,0,0,.434-1.106.6.6,0,0,0-.258-.468,2.78,2.78,0,0,1-.384-.318,2.671,2.671,0,0,1,0-3.779l2.494-2.493a2.672,2.672,0,1,1,3.754,3.8l-.486.486a.6.6,0,0,0-.14.616,6.838,6.838,0,0,1,.36,1.956A.593.593,0,0,0,15.973,11L17.35,9.626a5.647,5.647,0,0,0,0-7.977Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLink);
export default __webpack_public_path__ + "static/media/webLink.9933e7223d72966e7182a7fc35ec5582.svg";
export { ForwardRef as ReactComponent };